var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00001 0.449951C7.44184 0.449951 7.80001 0.808123 7.80001 1.24995V7.70366L10.2148 5.53032C10.5432 5.23475 11.0491 5.26137 11.3446 5.58978C11.6402 5.91819 11.6136 6.42402 11.2852 6.71959L7.53518 10.0946C7.23094 10.3684 6.76908 10.3684 6.46484 10.0946L2.71484 6.71959C2.38643 6.42402 2.35981 5.91819 2.65538 5.58978C2.95094 5.26137 3.45678 5.23475 3.78518 5.53032L6.20001 7.70366V1.24995C6.20001 0.808123 6.55818 0.449951 7.00001 0.449951ZM1.00001 9.57495C1.44184 9.57495 1.80001 9.93312 1.80001 10.375V11.5C1.80001 11.8866 2.11341 12.2 2.50001 12.2H11.5C11.8866 12.2 12.2 11.8866 12.2 11.5V10.375C12.2 9.93312 12.5582 9.57495 13 9.57495C13.4418 9.57495 13.8 9.93312 13.8 10.375V11.5C13.8 12.7702 12.7703 13.8 11.5 13.8H2.50001C1.22976 13.8 0.200012 12.7702 0.200012 11.5V10.375C0.200012 9.93312 0.558184 9.57495 1.00001 9.57495Z",
    fill: "#002CFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/iconDownload.e31d4909bfb0961d302acebd97883f35.svg";
export { ForwardRef as ReactComponent };